import { useHeaderBranding } from '../hooks/useHeaderBranding';
import { cn } from '@/lib/utils';

interface PageBrandingLogoProps {
  className?: string;
}

/** Logged-in user's organisation branding for page headers (e.g. dashboard top-right). */
export default function PageBrandingLogo({ className }: PageBrandingLogoProps) {
  const { logoSrc, name } = useHeaderBranding();

  if (!logoSrc) {
    return null;
  }

  return (
    <img
      src={logoSrc}
      alt={name ? `${name} logo` : 'Branding'}
      title={name ?? undefined}
      className={cn('h-14 max-w-[240px] w-auto object-contain flex-shrink-0', className)}
    />
  );
}
